<template>
    <div v-if="ready" class="col-sm-9 mx-auto maincontainer">
        <div class="col-sm-12 mt-3 headingRow">
            <font-awesome-icon icon="box-open" size="3x" />
            <h3 style="padding-left:10px">{{ $t('menu.shipment.history') }}</h3>
        </div>

        <historyFilter @fetchHistoryShipments="historyShipments" @fetchDocumentPack="DocumentPack" :spinnerLoading="spinnerLoading" />

        <historyList :items="getShipments" v-if="getShipments.length && !spinnerLoading" />

        <p id="noElements" v-if="getShipments.length === 0 && this.spinnerLoading === false">
            {{ $t('errors.NoShipmentsFound') }}
        </p>

        <!-- <bottomButtons v-if="getShipments.length"></bottomButtons> -->
    </div>
</template>

<script>
import store from '../store/';
import { CORE_PREFIX, ACTIONS, HISTORY_PREFIX, MUTATIONS } from '../store/constants';
import vSelect from '../components/vSelect';
import 'vue-select/dist/vue-select.css';
import historyFilter from '../components/History/historyFilter';
import historyList from '../components/History/historyList';
// import bottomButtons from '../components/History/historyBottomButtons';
import { mapGetters } from 'vuex';

export default {
    components: {
        vSelect,
        historyFilter,
        historyList
        // bottomButtons
    },

    computed: {
        ...mapGetters('history', ['getShipments']),
        isTableBusy(){
            return this.tableBusy;
        }
    },

    data() {
        return {
            spinnerLoading: false,
            ready: false,
        };
    },

    methods: {
        async historyShipments(filter) {
            this.spinnerLoading = true;

            await this.$store.dispatch(
                HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_HISTORY_SHIPMENTS,
                filter
            );

            this.spinnerLoading = false;
        },
        async DocumentPack(filter){
          this.spinnerLoading = true;

          await this.$store.dispatch(
              HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_DOCUMENT_PACK,
              filter
          );
          
          this.spinnerLoading = false;
        }
    },

    async created() {
        await this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.INITIALIZE_HISTORY);

        this.ready = true;

        this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
    }
};
</script>
<style>
#noElements {
    padding-top: 15px;
    font-size: 25px;
}
</style>
